import { Controller } from "stimulus";
import Tagify from '@yaireo/tagify'

export default class extends Controller {
  static targets = [
    "input",
    "tagSuggestion",
    "hiddenInput"
  ];

  initTagify() {
    this.inputName = this.inputTarget.name;
    this.inputTarget.name = `_tagify_${this.inputName}`
    const tagify = new Tagify(this.inputTarget, {
      whitelist: [],
      editTags: false,
      dropdown: {
        classname: "color-blue",
        enabled: 1,
        maxItems: 5,
        position: "input"
      },
      callbacks: {
        add: t => this.addTagCallback(t.detail.data),
        remove: t => this.removeTagCallback(t.detail.data)
      }
    });

    let abortController;
    let preValue = "";
    // サジェスト取得
    tagify.on('input', e => {
      var value = e.detail.value;

      // 先頭文字が同じなら新しいサジェストは出ないので検索しない
      if(preValue.charAt(0) === value.charAt(0)) {
        preValue = value;
        return;
      }

      preValue = value;
      tagify.whitelist = null; // reset the whitelist

      // https://developer.mozilla.org/en-US/docs/Web/API/AbortController/abort
      abortController && abortController.abort();
      abortController = new AbortController();

      // show loading animation and hide the suggestions dropdown
      tagify.loading(true).dropdown.hide();

      fetch(`/skill_suggestions.json?name=${value}`, {signal: abortController.signal})
        .then(RES => RES.json())
        .then(function(newWhitelist){
          tagify.whitelist = newWhitelist // update whitelist Array in-place
          tagify.loading(false).dropdown.show(value) // render the suggestions dropdown
        })
    });

    const viewportWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    // viewport widthが480px以下だと`position: input`がきかず
    // dropdown位置がおかしくなるため無理やり調整
    // https://github.com/yairEO/tagify/blob/master/src/parts/dropdown.js#L244
    if (viewportWidth <= 480) {
      tagify.dropdown.position = function(ddHeight) {
        const rect = tagify.DOM.input.getBoundingClientRect();
        tagify.DOM.dropdown.style.top = rect.top + window.pageYOffset + rect.height;
        tagify.DOM.dropdown.style.left = rect.left + window.pageXOffset;
        tagify.DOM.dropdown.style.width = rect.width;
        tagify.DOM.dropdown.setAttribute("position", "input");
      }
    }
    return tagify;
  }

  addTagCallback(tagData) {
    // タグと一致するhiddenタグを生成する
    // サーバではhiddenタグの値のみを使用する
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = `${this.inputName}[]`;
    input.value = tagData.value;
    input.dataset.target = "skill-tag-field.hiddenInput";
    this.element.appendChild(input);

    const tagSuggestion = this.tagSuggestionTargets.find(t => t.dataset.value === tagData.value)
    if(tagSuggestion) {
      tagSuggestion.style.display = "none";
    }
  }

  removeTagCallback(tagData) {
    this.hiddenInputTargets.find(h => h.value === tagData.value).remove();

    const tagSuggestion = this.tagSuggestionTargets.find(t => {
      return t.dataset.value === tagData.value && this.professionId === Number(t.dataset.professionId)
    });
    if(tagSuggestion) {
      tagSuggestion.style.display = "";
    }
  }

  addTagFromTagSuggestion(e) {
    this.tagify.addTags([e.currentTarget.dataset.value]);
  }

  setProfessionId(professionId) {
    this.professionId = Number(professionId);
    const values = this.tagify.value.map(hash => hash.value);
    this.tagSuggestionTargets.forEach(tag => {
      if(Number(tag.dataset.professionId) === this.professionId && !values.includes(tag.dataset.value)) {
        tag.style.display = "";
      } else {
        tag.style.display = "none";
      }
    });
  }

  connect() {
    this.tagify = this.initTagify();
    this.tagify.value.forEach(tagData => this.addTagCallback(tagData));
    this.setProfessionId(this.element.dataset.professionId);
  }

  disconnect() {
    this.inputTarget.name = this.inputName;
    this.hiddenInputTargets.forEach(h => h.remove());
    this.tagify.destroy();
  }
}
